import { useState, useEffect } from "react";

// <img> that recovers instead of staying blank. Product thumbnails come from a resizing CDN whose first
// request for a picture can be slow or fail on a weak connection (Instagram's in-app browser). On error:
// retry the thumbnail once (cache-busted), then fall back to the original file.
export default function SafeImg({ src, fallback, ...rest }) {
  const [stage, setStage] = useState(0); // 0 = thumb, 1 = retry thumb, 2 = original
  useEffect(() => { setStage(0); }, [src, fallback]);
  const url = stage === 0 ? src
    : stage === 1 ? `${src}${String(src).includes("?") ? "&" : "?"}r=1`
    : (fallback || src);
  return <img {...rest} src={url} onError={() => { if (stage < 2 && (stage === 0 || fallback)) setStage(s => (s === 0 ? 1 : 2)); }} />;
}
